import "core-js/modules/es6.object.assign";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { convertLazy, transformValues } from '../../../utilities/responsive';

var _convertResponsiveUnitsToValues = function _convertResponsiveUnitsToValues(responsiveUnits, theme) {
  return transformValues(responsiveUnits, function (unitValue) {
    return theme.units.getValue(unitValue);
  });
};

var _responsiveLayout = function _responsiveLayout(ruleName, theme, base, top, right, left, bottom, vertical, horizontal) {
  // make props responsive
  var rRoot = convertLazy(base);
  var rTop = convertLazy(top);
  var rRight = convertLazy(right);
  var rLeft = convertLazy(left);
  var rBottom = convertLazy(bottom);
  var rVertical = convertLazy(vertical);
  var rHorizontal = convertLazy(horizontal); // unify into single dictionaries per side and transform into values

  var unifiedTop = _convertResponsiveUnitsToValues(__assign(__assign(__assign({
    xs: 0
  }, rRoot), rVertical), rTop), theme);

  var unifiedRight = _convertResponsiveUnitsToValues(__assign(__assign(__assign({
    xs: 0
  }, rRoot), rHorizontal), rRight), theme);

  var unifiedBottom = _convertResponsiveUnitsToValues(__assign(__assign(__assign({
    xs: 0
  }, rRoot), rVertical), rBottom), theme);

  var unifiedLeft = _convertResponsiveUnitsToValues(__assign(__assign(__assign({
    xs: 0
  }, rRoot), rHorizontal), rLeft), theme); // return responsive rules for each side


  return theme.responsive.cssPropsForBreakpointValues(unifiedTop, ruleName + "-top") + "; " + theme.responsive.cssPropsForBreakpointValues(unifiedRight, ruleName + "-right") + "; " + theme.responsive.cssPropsForBreakpointValues(unifiedBottom, ruleName + "-bottom") + "; " + theme.responsive.cssPropsForBreakpointValues(unifiedLeft, ruleName + "-left") + ";";
};

export var getPadding = function getPadding(_a) {
  var theme = _a.theme,
      p = _a.p,
      pt = _a.pt,
      pr = _a.pr,
      pl = _a.pl,
      pb = _a.pb,
      pv = _a.pv,
      ph = _a.ph;
  return _responsiveLayout('padding', theme, p, pt, pr, pl, pb, pv, ph);
};
export var getMargin = function getMargin(_a) {
  var theme = _a.theme,
      m = _a.m,
      mt = _a.mt,
      mr = _a.mr,
      ml = _a.ml,
      mb = _a.mb,
      mv = _a.mv,
      mh = _a.mh;
  return _responsiveLayout('margin', theme, m, mt, mr, ml, mb, mv, mh);
};

var _borderInnerValue = function _borderInnerValue(theme, borderColor, borderStrokeWidth, borderStyle) {
  return function (border) {
    if (border && typeof border === 'boolean') {
      return borderStyle + " " + (borderStrokeWidth || theme.strokeWidths["default"]) + " " + String(theme.colors[borderColor] || borderColor);
    } else if (border) {
      return border;
    }

    return 'none';
  };
};

var _border = function _border(propType, theme, borderColor, borderStyle, border, borderStrokeWidth) {
  if (!border) {
    return '';
  }

  var transformationFn = _borderInnerValue(theme, borderColor, borderStrokeWidth, borderStyle);

  var borderValues = theme.responsive.transformValues(border, transformationFn);
  return theme.responsive.cssPropsForBreakpointValues(borderValues, propType);
};

export var getBorder = function getBorder(_a) {
  var theme = _a.theme,
      b = _a.b,
      bt = _a.bt,
      br = _a.br,
      bb = _a.bb,
      bl = _a.bl,
      borderColor = _a.borderColor,
      borderStrokeWidth = _a.borderStrokeWidth,
      borderStyle = _a.borderStyle;

  if (b) {
    return _border('border', theme, borderColor, borderStyle, convertLazy(b), borderStrokeWidth) + ";";
  }

  return "\n        " + _border('border-top', theme, borderColor, borderStyle, convertLazy(bt), borderStrokeWidth) + ";\n        " + _border('border-right', theme, borderColor, borderStyle, convertLazy(br), borderStrokeWidth) + ";\n        " + _border('border-bottom', theme, borderColor, borderStyle, convertLazy(bb), borderStrokeWidth) + ";\n        " + _border('border-left', theme, borderColor, borderStyle, convertLazy(bl), borderStrokeWidth) + ";\n    ";
};